import { render } from "./AboutUsManagement.vue?vue&type=template&id=3bd5d3c6&scoped=true"
import script from "./AboutUsManagement.vue?vue&type=script&lang=js"
export * from "./AboutUsManagement.vue?vue&type=script&lang=js"

import "./AboutUsManagement.vue?vue&type=style&index=0&id=3bd5d3c6&lang=scss&scoped=true"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd5d3c6"]])

export default __exports__